import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://xxdnxsybzftrkpomfzrw.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh4ZG54c3liemZ0cmtwb21menJ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE3MDE3MzgsImV4cCI6MjA5NzI3NzczOH0.EYrZPCTHY0-Cut5fD-ejXt7MKV8nkJ_LI7F8ISivOfA';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
